export default __webpack_public_path__ + "static/media/qr.dc1aed96.jpg";